// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__NnVSP","rightAdornment":"Header_rightAdornment__3MUxd"};